<template>
  <div class="process-timeline" :class="{'dark':skinType}" style="text-align: left;">
    <el-timeline>
      <el-timeline-item
        v-for="(timeline, index) in timelineList"
        :key="index"
        :timestamp="timeline.F_CreateDate"
        placement="top">
        <el-card class="d-flex flex-column">
          <div>{{timeline.F_NodeName}}</div>
          <div> 【{{timeline.F_CreateUserName}}】{{timeline.F_Result==1?'通过':'未通过'}}</div>
          <div v-if="timeline.F_Description">描述:{{timeline.F_Description}}</div>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
import { getTaskFormAndHistory } from '@/api/equipment-operational/index';

export default {
  name: 'process-timeline',
  props: {
    selectProcessInfo: {
      type: Object,
    },
  },
  data() {
    return {
      timelineList: [],
    };
  },
  created() {
    this.requestTimeLine();
  },
  computed: {
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  watch: {
    selectProcessInfo() {
      this.requestTimeLine();
    },
  },
  methods: {
    requestTimeLine() {
      if (!this.selectProcessInfo) {
        return;
      }
      getTaskFormAndHistory({
        processid: this.selectProcessInfo.F_Id ? this.selectProcessInfo.F_Id
          : this.selectProcessInfo.F_ProcessId,
        taskid: this.selectProcessInfo.F_TaskId ? this.selectProcessInfo.F_TaskId
          : this.selectProcessInfo.F_NodeId,
      }).then((res) => {
        console.log(res);
        this.timelineList = res.data.history;
      });
    },
  },
};
</script>
<style >
.dark.process-timeline .el-timeline-item__timestamp {
  background-color: #223388;
  color: #fff  !important;
}
.dark.process-timeline .el-card{
  background-color: #3344aa;
  color: #fff;
}
</style>
